/** Alinhado ao app (`app-native-fortio/src/utils/authIdentity.js`). */
export const CPF_AUTH_EMAIL_DOMAIN = "motorista.fortio.com.br";

export function onlyDigits(value) {
  return String(value || "").replace(/\D/g, "");
}

export function isValidCpf(value) {
  const cpf = onlyDigits(value);
  if (cpf.length !== 11) return false;
  if (/^(\d)\1{10}$/.test(cpf)) return false;

  let sum = 0;
  for (let i = 0; i < 9; i += 1) {
    sum += Number(cpf[i]) * (10 - i);
  }
  let check = (sum * 10) % 11;
  if (check === 10 || check === 11) check = 0;
  if (check !== Number(cpf[9])) return false;

  sum = 0;
  for (let i = 0; i < 10; i += 1) {
    sum += Number(cpf[i]) * (11 - i);
  }
  check = (sum * 10) % 11;
  if (check === 10 || check === 11) check = 0;
  return check === Number(cpf[10]);
}

export function emailFromCpf(cpf) {
  return `${onlyDigits(cpf)}@${CPF_AUTH_EMAIL_DOMAIN}`;
}

export function isTechnicalAuthEmail(email) {
  const value = String(email || "")
    .trim()
    .toLowerCase();
  if (!value) return false;
  return value.endsWith(`@${CPF_AUTH_EMAIL_DOMAIN}`);
}

/** Converte telefone BR mascarado/cru para E.164 (+55...). */
export function toE164BR(maskedOrRaw) {
  const digits = onlyDigits(maskedOrRaw);
  if (!digits) return "";
  if (digits.startsWith("55") && digits.length >= 12) {
    return `+${digits}`;
  }
  return `+55${digits}`;
}
